module.exports = __webpack_public_path__ + "web/img/img1.9e0164d3.png";